import React from 'react';

const Card = ({ format, img, id, name, color, images_regular, power }) => {
  //Passing in the object w/ the properties you need for each card from CardList

  return (
    <article className="card" onClick={() => {}}>
      <img src={images_regular[0]} alt={name} />
      <div></div>
    </article>
  );
};

export default Card;
